import React from "react";
import {Project} from "interfaces";
import {Col, Row, Skeleton} from "antd";
import ReactGA from "react-ga";

interface Props {
    isLoading  : boolean,
    datasource : Project[],
    openModal  : (image : string, title : string, desc : string) => void,
    filter      : string,
}

const Card : React.FC<Props> = ({isLoading, datasource, openModal, filter}) => {

    return (
        <Row gutter={[20, 10]}>
            {
                (isLoading ? new Array(25).fill({}, 0, 6) : datasource)
                    .filter((item : Project) => filter === "Semua" ? item : item.category === filter)
                    .map((item : Project, x) => (
                        <Col
                            key={x}
                            lg={8}
                            md={8}
                            sm={24}
                            xs={24}
                            onClick={() => {
                                openModal(item?.image?.url || "", item.title, item.description);
                                ReactGA.event({category : "Portofolio", action : "clicked", label : "view_detail_" + item.title?.replace(/ /g, "_") })
                            }}
                        >
                            <div className={"card-list"}>
                                <div className={"image-section"}>
                                    {
                                        isLoading
                                            ? <Skeleton.Avatar size={500} shape={"square"} active={true} />
                                            : <img src={item.image.url} alt={item.title} />
                                    }
                                </div>
                                <div className={"card-list-text"}>
                                    {
                                        isLoading
                                            ? <Skeleton active={true} paragraph={{rows : 0}} />
                                            : <h3>{item.title}</h3>
                                    }
                                    <p>
                                        {
                                            item.description?.length > 100
                                                ? item.description.slice(0, 100) + " ..."
                                                : item.description
                                        }
                                    </p>
                                </div>
                            </div>
                        </Col>
                    ))
            }
        </Row>
    )
}

export default React.memo(Card);